module.exports = __webpack_public_path__ + "img/4.04.thmb.xs.b95b68b6.jpg";